import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import { Building2, Hash, Sparkles, X } from 'lucide-react';
import './CreateWorkspaceModal.scss';

export default function CreateWorkspaceModal({
    open,
    creating,
    formData,
    errors,
    onClose,
    onSubmit,
    onOrgNameChange,
    onTagChange,
}) {
    return (
        <Dialog
            open={open}
            onClose={() => !creating && onClose()}
            maxWidth="sm"
            fullWidth
            PaperProps={{ className: 'createWorkspaceModal' }}
        >
            <DialogTitle className="createWorkspaceModal__header">
                <div className="createWorkspaceModal__titleWrap">
                    <div className="createWorkspaceModal__icon">
                        <Sparkles size={16} />
                    </div>
                    <div className="createWorkspaceModal__titleText">
                        <h3>Create New Workspace</h3>
                        <p>Set up a dedicated Resolve workspace for your team.</p>
                    </div>
                </div>
                <button
                    className="createWorkspaceModal__close"
                    onClick={onClose}
                    disabled={creating}
                    aria-label="Close dialog"
                >
                    <X size={18} />
                </button>
            </DialogTitle>

            <DialogContent className="createWorkspaceModal__content">
                <div className="createWorkspaceModal__form">
                    <div className="createWorkspaceModal__fieldGroup">
                        <label className="createWorkspaceModal__fieldLabel" htmlFor="workspace-org-name">
                            <Building2 size={14} />
                            <span>Organization Name</span>
                        </label>
                        <TextField
                            id="workspace-org-name"
                            fullWidth
                            placeholder="e.g. Acme Corporation"
                            value={formData.orgName}
                            onChange={(e) => onOrgNameChange(e.target.value)}
                            error={!!errors.orgName}
                            helperText={errors.orgName || 'This is how your workspace will be identified.'}
                            disabled={creating}
                            variant="outlined"
                            size="small"
                        />
                    </div>

                    <div className="createWorkspaceModal__fieldGroup">
                        <label className="createWorkspaceModal__fieldLabel" htmlFor="workspace-tag">
                            <Hash size={14} />
                            <span>Default Form Tag</span>
                        </label>
                        <TextField
                            id="workspace-tag"
                            fullWidth
                            placeholder="6-letter code (e.g. ACMECR)"
                            value={formData.defaultResolveTag}
                            onChange={(e) => onTagChange(e.target.value)}
                            error={!!errors.defaultResolveTag}
                            helperText={
                                errors.defaultResolveTag ||
                                'Filled in from the organization name — exactly 6 characters, ending in a letter. Edit it if you\'d like.'
                            }
                            disabled={creating}
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 6 }}
                        />
                    </div>
                </div>
            </DialogContent>

            <DialogActions className="createWorkspaceModal__actions">
                <button
                    onClick={onClose}
                    disabled={creating}
                    className="createWorkspaceModal__cancel"
                >
                    Cancel
                </button>
                <button
                    onClick={onSubmit}
                    disabled={creating}
                    className="createWorkspaceModal__submit"
                >
                    {creating ? (
                        <>
                            <CircularProgress size={14} color="inherit" style={{ marginRight: '6px' }} />
                            Creating...
                        </>
                    ) : (
                        'Create Workspace'
                    )}
                </button>
            </DialogActions>
        </Dialog>
    );
}
